/* ------------------------------------------------------------------
   BOOBIE CART EXTRAS
   --------------------------------------------------------------------
   Shipping Protection toggle for the custom cart drawer. Adds/removes
   the protection product (variant 45939303383180 — a real charged line,
   hidden from the item list by line-item.liquid) and re-renders the
   drawer through the theme's own bundled-sections flow.
------------------------------------------------------------------ */
(function () {
  var PROTECTION_VARIANT = 51511546773644;          // our own $2.50 Service product
  var LEGACY_PROTECTION_VARIANT = 45939303383180;   // UpCart's — still swept if present
  var busy = false;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  async function rerenderDrawer() {
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true, detail: { sections: sectionsToBundle }
    }));
    var cart = await fetch(root() + 'cart.js').then(function (r) { return r.json(); });
    if (sectionsToBundle.length) {
      var sections = await fetch(root() + '?sections=' + sectionsToBundle.join(',')).then(function (r) { return r.json(); });
      cart.sections = sections;
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true, detail: { baseEvent: 'cart:refresh', cart: cart }
    }));
  }

  function updateCheckoutTotal(totalCents) {
    var btn = document.querySelector('.bcart__checkout');
    if (!btn || typeof totalCents !== 'number') return;
    var money = (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(totalCents)
      : '$' + (totalCents / 100).toFixed(2);
    btn.innerHTML = 'Checkout &nbsp;&middot;&nbsp; ' + money;
  }

  async function toggleProtection(btn) {
    if (busy) return;
    busy = true;
    // Optimistic: flip the switch instantly, settle the cart in the background.
    var turningOn = !btn.classList.contains('is-on');
    btn.classList.toggle('is-on', turningOn);
    btn.setAttribute('aria-pressed', String(turningOn));
    try {
      var cart = await fetch(root() + 'cart.js').then(function (r) { return r.json(); });
      var line = cart.items.find(function (it) {
        return it.variant_id === PROTECTION_VARIANT || it.variant_id === LEGACY_PROTECTION_VARIANT;
      });
      var newCart;
      if (!turningOn && line) {
        newCart = await fetch(root() + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        }).then(function (r) { return r.json(); });
      } else if (turningOn && !line) {
        await fetch(root() + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: PROTECTION_VARIANT, quantity: 1 }] })
        });
        newCart = await fetch(root() + 'cart.js').then(function (r) { return r.json(); });
      }
      if (newCart) updateCheckoutTotal(newCart.total_price);
    } catch (e) {
      // Roll the switch back if the cart call failed.
      btn.classList.toggle('is-on', !turningOn);
      btn.setAttribute('aria-pressed', String(!turningOn));
    } finally {
      busy = false;
    }
  }

  // Server-side price can render blank while a freshly created product
  // propagates to Liquid's all_products — backfill it client-side.
  function fillProtectPrice() {
    var el = document.querySelector('.bcart__protect-price');
    if (!el || el.textContent.trim() !== '') return;
    fetch(root() + 'products/shipping-protection-1.js')
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (p) {
        var cents = p.variants[0].price;
        el.textContent = (window.Shopify && Shopify.formatMoney)
          ? Shopify.formatMoney(cents).replace(/&[a-z]+;/g, '')
          : '$' + (cents / 100).toFixed(2);
      })
      .catch(function () { el.textContent = '$2.00'; });
  }
  if (document.readyState !== 'loading') fillProtectPrice();
  else document.addEventListener('DOMContentLoaded', fillProtectPrice);
  new MutationObserver(fillProtectPrice).observe(document.body, { childList: true, subtree: true });

  // Preview-bar detection (mobile testing: the preview bar overlays the footer)
  function flagPreviewBar() {
    var bar = document.querySelector('#PBarNextFrameWrapper, #preview-bar-iframe, iframe[src*="preview-bar"]');
    var visible = false;
    if (bar) {
      var r = bar.getBoundingClientRect();
      visible = r.height > 10 && getComputedStyle(bar).display !== 'none';
    }
    document.documentElement.classList.toggle('has-preview-bar', visible);
  }
  flagPreviewBar();
  setTimeout(flagPreviewBar, 2000);
  setTimeout(flagPreviewBar, 5000);

  // Checkout: navigate directly — immune to form quirks under preview overlays.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.bcart__checkout');
    if (!btn) return;
    e.preventDefault();
    window.location.href = root() + 'checkout';
  }, true);

  // Delegated — survives drawer re-renders.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-protect-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggleProtection(btn);
  });

  // Never charge protection on an otherwise-empty bag: if it's the only
  // line left, remove it. Also sweep the $0 Sterling Complimentary Engraving
  // line if no bracelet with engraving props remains — a lone engraving line
  // would tag the order "Engraving" with nothing to engrave.
  var FREE_ENGRAVING_VARIANT = 45408045236364;
  async function protectionOrphanCheck() {
    try {
      var cart = await fetch(root() + 'cart.js').then(function (r) { return r.json(); });
      var freeEng = cart.items.find(function (it) { return it.variant_id === FREE_ENGRAVING_VARIANT; });
      var hasEngraved = cart.items.some(function (it) {
        return it.variant_id !== FREE_ENGRAVING_VARIANT && it.properties && it.properties['_Engraving text '];
      });
      if (freeEng && !hasEngraved) {
        await fetch(root() + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: freeEng.key, quantity: 0 })
        });
        cart = await fetch(root() + 'cart.js').then(function (r) { return r.json(); });
        await rerenderDrawer();
      }
      var only = cart.items.length === 1 && (cart.items[0].variant_id === PROTECTION_VARIANT || cart.items[0].variant_id === LEGACY_PROTECTION_VARIANT);
      if (only) {
        await fetch(root() + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: cart.items[0].key, quantity: 0 })
        });
        await rerenderDrawer();
      }
    } catch (e) { /* fail quiet */ }
  }
  document.addEventListener('cart:change', function () { setTimeout(protectionOrphanCheck, 400); });
})();
